import { TagInterface } from 'riot';
import cadastreReportStore, { CadastreReportState } from '../../stores/cadastreReport';
import * as cadastreReportConstants from '../../constants/cadastreReport';

const { events: cadastreReportEvents } = cadastreReportConstants;

export interface CadastreReportErrorTag extends TagInterface {
  lookupData: CadastreReportState;
}

export const init = (tag: CadastreReportErrorTag): void => {
  tag.lookupData = {};

  const onCadastreLookupLoading = (): void => {
    tag.lookupData = null;
    tag.update();
  };

  const onCadastreLookupLoaded = (): void => {
    tag.lookupData = cadastreReportStore.getState();
    tag.update();
  };

  tag.on('mount', () => {
    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADING, onCadastreLookupLoading);
    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, onCadastreLookupLoaded);
  });

  tag.on('unmount', () => {
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADING, onCadastreLookupLoading);
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, onCadastreLookupLoaded);
  });
};
